"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSendgridTemplateResponseToJSON = exports.GetSendgridTemplateResponseFromJSONTyped = exports.GetSendgridTemplateResponseFromJSON = void 0;
var _1 = require("./");
function GetSendgridTemplateResponseFromJSON(json) {
    return GetSendgridTemplateResponseFromJSONTyped(json, false);
}
exports.GetSendgridTemplateResponseFromJSON = GetSendgridTemplateResponseFromJSON;
function GetSendgridTemplateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'generation': json['generation'],
        'updated_at': json['updated_at'],
        'versions': (json['versions'].map(_1.SendgridTemplateVersionFromJSON)),
    };
}
exports.GetSendgridTemplateResponseFromJSONTyped = GetSendgridTemplateResponseFromJSONTyped;
function GetSendgridTemplateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'generation': value.generation,
        'updated_at': value.updated_at,
        'versions': (value.versions.map(_1.SendgridTemplateVersionToJSON)),
    };
}
exports.GetSendgridTemplateResponseToJSON = GetSendgridTemplateResponseToJSON;
